





























import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import RatingBanner from '@/components/Profile/Ratings/RatingBanner.vue';

export default Vue.extend({
    name: 'PortfolioIntro',

    data() {
        return {};
    },

    methods: {},

    computed: {
        ...mapGetters(['getActor', 'getSampleMp3Url']),
    },

    components: {
        Mp3Player,
        RatingBanner,
    },
});
